import { formatNumberToKNotation } from 'helpers';
import { Image, Skeleton, SkeletonizedValue } from '@round/ui-kit';
import styles from './UserBadge.module.css';

export type UserBadgeProps = {
    isLoading: boolean;
    image: string | undefined;
    title: string;
    followerCount?: number | null;
    profileUrl?: string | null;
};

const UserBadge = ({ isLoading, image, title, followerCount, profileUrl }: UserBadgeProps) => {
    return (
        <div className={styles.container}>
            <Image loading={isLoading} src={image} className={styles.image} />
            <div className={styles.details}>
                {isLoading ? (
                    <Skeleton width="7rem" />
                ) : profileUrl ? (
                    <a href={profileUrl} target="_blank" rel="noopener noreferrer">
                        {title}
                    </a>
                ) : (
                    <p>{title}</p>
                )}
                {followerCount === undefined ? null : (
                    <p className={styles.followerCount}>
                        <SkeletonizedValue isInitialized={!isLoading}>
                            {typeof followerCount === 'number' ? formatNumberToKNotation(followerCount) : '-'}
                        </SkeletonizedValue>
                    </p>
                )}
            </div>
        </div>
    );
};

export default UserBadge;
